import { cn } from "../../lib/utils";

/**
 * Egységes szekciófej Studio nézethez (admin oldalak).
 */
export function StudioSection({ id, title, subtitle, children, className }) {
  return (
    <section className={cn("space-y-3", className)} aria-labelledby={id}>
      <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between border-b border-slate-800/80 pb-2">
        <h2 id={id} className="text-sm font-semibold text-slate-200 tracking-tight">
          {title}
        </h2>
        {subtitle ? <p className="text-[11px] text-slate-500">{subtitle}</p> : null}
      </div>
      {children}
    </section>
  );
}
